import { Audience } from '@/domain/types/audience';
import { listAudiences } from '@/domain/use-cases/audiences/audience-service';
import { useEffect, useState } from 'react';

interface AudienceSelectProps {
  value: string[];
  onChange: (audienceIds: string[]) => void;
  /** Texto que se muestra cuando no hay ninguna audiencia seleccionada. */
  emptyLabel: string;
  /** Texto explicativo bajo el selector. */
  helpText: string;
  error?: string;
}

const AudienceSelect = ({
  value,
  onChange,
  emptyLabel,
  helpText,
  error,
}: AudienceSelectProps) => {
  const [audiences, setAudiences] = useState<Audience[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    listAudiences()
      .then((all) => setAudiences(all.filter((a) => a.isActive)))
      .catch((e) => console.error('Error cargando audiencias:', e))
      .finally(() => setIsLoading(false));
  }, []);

  const toggle = (id: string) => {
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  };

  if (isLoading) {
    return <p className="text-sm text-gray-500">Cargando audiencias...</p>;
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1 max-h-48 overflow-y-auto border rounded p-2">
        {audiences.length === 0 && (
          <p className="text-sm text-gray-500">No hay audiencias creadas.</p>
        )}
        {audiences.map((audience) => (
          <label key={audience.id} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={value.includes(audience.id)}
              onChange={() => toggle(audience.id)}
            />
            <span>{audience.name}</span>
          </label>
        ))}
      </div>
      {value.length === 0 && (
        <p className="text-sm font-medium">{emptyLabel}</p>
      )}
      <p className="text-xs text-gray-500">{helpText}</p>
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default AudienceSelect;
